import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { Box } from '@sternum/styled-system';
import { Icon } from '@sternum/web/components';
import { TextOverflowBox } from '@sternum/web/components/TextOverflowBox';
import { routes } from '@sternum/web/config/routes';
import { useGeneratePathWithCurrentClient } from '@sternum/web/features/auth/hooks';
import { Dashboard, DashboardId } from '@sternum/web/features/dashboard/models';
import { setIsJustCreatedForDashboardIdAction } from '@sternum/web/features/dashboard/slice';
import { useAppDispatch, useAppSelector } from '@sternum/web/store';

import { MenuItemLink } from '../../MenuItemLink';
import { dashboardNameTooltipProps } from '../DashboardsMenu.utils';

import { MenuSectionStyled } from '../DashboardsMenu.styles';

export type DashboardListType = Pick<Dashboard, 'id' | 'title' | 'isCreating'>;

export interface DashboardsListProps extends Omit<ComponentPropsWithoutRef<'div'>, 'title'> {
  title: ReactNode;
  list: DashboardListType[];
}

export function DashboardsList({ title, list, ...props }: DashboardsListProps) {
  const generatePath = useGeneratePathWithCurrentClient();
  const dispatch = useAppDispatch();
  const isJustCreatedPerDashboardId = useAppSelector((state) => state.dashboard.isJustCreatedPerDashboardId);

  const setIsJustCreated = (dashboardId: DashboardId, isJustCreated: boolean) => {
    dispatch(setIsJustCreatedForDashboardIdAction({ dashboardId, isJustCreated }));
  };

  const renderPrivateIcon = (dashboard: DashboardListType) => {
    return isJustCreatedPerDashboardId[dashboard.id] || dashboard.isCreating ? (
      <Icon type="LockWithDotIcon" size={12} />
    ) : (
      <Icon type="LockIcon" size={12} />
    );
  };

  // const renderPublicIcon = (dashboard: DashboardListType) => {
  //   return isJustCreatedPerDashboardId[dashboard.id] || dashboard.isCreating ? (
  //     <Group1WithDotIcon width={12} height={12} />
  //   ) : (
  //     <Group1Icon width={12} height={12} />
  //   );
  // };

  return (
    <MenuSectionStyled title={title} menuContentProps={{ overflow: 'auto' }} {...props}>
      <Box ml={12}>
        {list.map((dashboard) => {
          const icon = renderPrivateIcon(dashboard);

          return (
            <MenuItemLink
              key={dashboard.id}
              to={generatePath(routes.dashboard.fullDashboard.absolute, { dashboardId: dashboard.id })}
              disabled={dashboard.isCreating}
              icon={icon}
              onClick={() => setIsJustCreated(dashboard.id, false)}
            >
              <Box overflow="hidden">
                <TextOverflowBox
                  tooltipThemeMode="Light"
                  tooltipContent={dashboard.title}
                  displayTooltipOnlyIfNeeded
                  tooltipProps={dashboardNameTooltipProps}
                >
                  {dashboard.title}
                </TextOverflowBox>
              </Box>
            </MenuItemLink>
          );
        })}
      </Box>
    </MenuSectionStyled>
  );
}
